// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';

import Icon_dots from '../../../img/icons/dots.svg';
import {Popup} from '../../popup/popup';

import styles from './action_menu.module.less';

type t_action_menu_item = {
    id: string;
    icon?: React.ComponentType;
    text: React.ReactNode;
    on_click: (id: string)=>void;
    btn_cls?: string;
};

type t_action_menu_props = {
    items: t_action_menu_item[];
    button_text?: React.ReactNode;
    cls?: string;
    popup_cls?: string;
    button_cls?: string;
    wrapper_cls?: string;
    menu_cls?: string;
    item_cls?: string;
    position?: 'left' | 'center' | 'right' | 'right_top' | 'top' | 'bottom';
    close_on_item_click?: boolean;
};

export const Action_menu =
({items, cls, item_cls, menu_cls, popup_cls, wrapper_cls, button_text,
    button_cls, close_on_item_click, position='left'}: t_action_menu_props)=>{
    if (items.length==0)
      return null;
    return <Popup on_toggle={ev=>ev?.stopPropagation()}
      position={position} wrapper_cls={wrapper_cls} button_cls={button_cls}
      close_on_item_click={close_on_item_click}
      button_text={button_text ??
        <Icon_dots className={cn(styles.dots, cls)}/>}
      popup_cls={cn(styles.popup, popup_cls)}>
      <div className={cn(styles.menu, menu_cls)}>
        {items.map(({id, on_click, text, icon: Icon, btn_cls})=>
          <button type="button" key={id}
            className={cn(styles.menu_item, item_cls, btn_cls)}
            onClick={e=>{
              if (!close_on_item_click)
                e.stopPropagation();
              on_click(id);
            }}>
            {Icon && <Icon />}{text}
          </button>)}
      </div>
    </Popup>;
};
